import Client from '@/generated/classes/Client';
export default class ClientExtend extends Client {
  constructor() {
    super();
  }
}
